export default (): boolean => {
  // if api is available and api key is provided
  if ("geolocation" in navigator && process.env.REACT_APP_GOOGLE_MAP_API_KEY) {
    return true;
  } else {
    return false;
  }
};
